import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconImage$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconImage extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8799e1780b394fe981b945ad0e98d4f4018c429f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4a4b5306688e89601e42ebbb4692519e26b034a9', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1d6a84dd9febf39da879d8a24871e0cf42b640d5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5zm16.5 12v-11h-15v11zm-5.68-6.39L10.14 14l-1.82-2.65a.24.24 0 0 0-.39 0L6 14.13a.23.23 0 0 0 .19.37h9.6a.23.23 0 0 0 .19-.37l-2.78-4a.24.24 0 0 0-.38-.02m-1.901-.998a1.17 1.17 0 0 1-1.089.718c-.64 0-1.16-.52-1.16-1.16a1.17 1.17 0 1 1 2.249.442", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-image", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-image"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-image":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconImage$1);
            }
            break;
    } });
}

const CosmosIconImage = CosmosIconImage$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconImage, defineCustomElement };
